(function() {
  if (App.angularApp == null) {
    return;
  }


  /*
      This directive allows clicking a different element to trigger a
      click event in the given input[file] element.It then calls the given
      callback function. Files are passed to the function.
  
      ------------ HTML
  
      <input type="file" id="fileinputid"/>
      <button
          mf-click-input-file="#fileinputid"
          mf-click-input-file-handler="controllerFunctionUpload"
      >
          Upload
      </button>
  
      ------------- ANGULARJS CONTROLLER
  
      controllerFunctionUpload: (files) =>
          ...
   */

  App.angularApp.directive('mfClickInputFile', function() {
    return {
      restrict: 'A',
      scope: {
        handler: '&mfClickInputFileHandler'
      },
      link: function(scope, element, attrs) {
        var handler, input;
        input = attrs.mfClickInputFile;
        handler = scope.handler();
        element.bind('click', (function(_this) {
          return function(e) {
            return angular.element(input).trigger('click');
          };
        })(this));
        return angular.element(input).bind('change', (function(_this) {
          return function(e) {
            handler(e.target.files);
            return angular.element(input).val('');
          };
        })(this));
      }
    };
  });

}).call(this);
